'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fPanel$002ejs from "@ui5/webcomponents/dist/Panel.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241 from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-String-Union-Codec$$anon$1.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.Ib = null;
  this.Ic = false;
  this.Id = null;
  this.Ie = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-panel");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$.prototype = $p;
$p.BK = (function() {
  if ((!this.Ic)) {
    this.Ib = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "header-level", new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241.$c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1()));
    this.Ic = true;
  }
  return this.Ib;
});
$p.BL = (function() {
  if ((!this.Ie)) {
    this.Id = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "header-text", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Ie = true;
  }
  return this.Id;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fPanel$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$, "io.github.nguyenyou.ui5.webcomponents.laminar.Panel$", ({
  jG: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Panel$ };
